<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Planes y Productos</h1>
              <p
                class="text-white mt-0 mb-5"
              >En esta sección se gestionan las propiedades de los Planes y Productos para Clientes.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-sm-9">
          <div class="card">
            <b-tabs pills card>
              <b-tab active>
                <template slot="title">
                  <i class="ni ni-cart mr-2"></i>
                  <strong>Ver Planes</strong>
                </template>
                <PlanesComponent />
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="ni ni-app mr-2"></i>
                  <strong>Ver Productos</strong>
                </template>
                <ProductosComponent />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlanesComponent from "./PlanesComponent";
import ProductosComponent from "./ProductosComponent";
import dealersService from "@/services/dealers.services";

export default {
  name: "planesProductos",
  components: {
    PlanesComponent,
    ProductosComponent
  },
  data() {
    return {
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/planes-productos"
      }
    };
  }
};
</script>